// Cầu nối service worker ↔ UI (Round 15): báo "Có bản cập nhật mới" khi DEV deploy bản mới.
//
// Vì sao cần: trước đây SW bị tắt hẳn vì sợ khách KẸT BẢN CŨ (SW phục vụ index.html đã
// precache). Nay bật SW (để Chrome Android bắn beforeinstallprompt → cài 1 chạm) thì
// bắt buộc phải có đường thoát: SW mới cài xong nằm ở trạng thái "waiting" → hiện thanh
// thông báo → NGƯỜI DÙNG bấm "Tải lại" → SKIP_WAITING → controllerchange → reload.
// KHÔNG bao giờ tự reload khi người dùng chưa đồng ý (đang xem dở số liệu).
//
// Registration có thể đến TRƯỚC khi React mount thanh thông báo → giữ lại trong module
// và phát lại cho subscriber đến sau.

let waitingRegistration = null;
const listeners = new Set();
// Chỉ reload khi chính người dùng bấm "Tải lại". Lần cài SW ĐẦU TIÊN clientsClaim() cũng
// bắn controllerchange — không được reload ở đó.
let userAccepted = false;

export const notifyUpdate = (registration) => {
  if (!registration || !registration.waiting) return;
  waitingRegistration = registration;
  listeners.forEach((fn) => fn(registration));
};

export const subscribeUpdate = (fn) => {
  listeners.add(fn);
  if (waitingRegistration) fn(waitingRegistration);
  return () => listeners.delete(fn);
};

export const applyUpdate = () => {
  const reg = waitingRegistration;
  if (!reg || !reg.waiting) {
    window.location.reload();
    return;
  }
  userAccepted = true;
  reg.waiting.postMessage({ type: 'SKIP_WAITING' });
};

export const initUpdateListeners = () => {
  if (!('serviceWorker' in navigator)) return;
  let reloading = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!userAccepted || reloading) return;
    reloading = true;
    window.location.reload();
  });
};

// App mở lại từ nền (PWA standalone trên điện thoại hầu như không bao giờ "load" lại)
// → hỏi server có service-worker.js mới không để phát hiện bản deploy sớm.
export const watchForUpdates = (registration) => {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      registration.update().catch(() => {});
    }
  });
};
